module.exports = __webpack_public_path__ + "img/cancel.4383ef46.svg";